import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/Home'
import About from '@/components/views/About'
import MySpace from '@/components/views/MySpace'
import MyWorkout from '@/components/views/MyWorkout'
import Philosphy from '@/components/views/Philosphy'
import SuccessStories from '@/components/views/SuccessStories'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'
import politicaCookies from '@/components/views/politica-de-cookies'
import avisoLegal from '@/components/views/aviso-legal'
import faqs from '@/components/views/faqs'
import Error404 from '@/components/views/error-404'


Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				title: "My WorkOut Studio - Entrenamiento personalizado",
				description:
					"ENTRENAMIENTO DE FUERZA EN EL CORAZÓN DE MADRID. Nos conocemos, vemos dónde estás y hacia dónde vas. AGENDA TU VALORACIÓN INICIAL.",
			}
		},
		{
			path: '/about',
			name: 'about',
			component: About,
			meta: {
				title: "My WorkOut Studio - About",
				description:
					"En 2011 decidí perseguir mi sueño: fomentar la actividad física y un estilo de vida saludable.",
			}
		},
		{
			path: '/my-space',
			name: 'myspace',
			component: MySpace,
			meta: {
				title: "My WorkOut Studio - My space",
				description:
					"La emoción y la motivación por una actividad se alimenta en parte por estímulos sensoriales por eso hemos diseñado y conceptualizado MY WORKOUT.",
			}
		},
		{
			path: '/my-workout',
			name: 'myworkout',
			component: MyWorkout,
			meta: {
				title: "My WorkOut Studio - My Workout",
				description:
					"Nuestro primer encuentro no es un entrenamiento, es una puesta en común de tus objetivos de entrenamiento y una VALORACIÓN global de tu capacidad de movimiento.",
			}
		},
		{
			path: '/philosphy',
			name: 'philosphy',
			component: Philosphy,
			meta: {
				title: "My WorkOut Studio - My Philoshophy",
				description:
					"Un entrenamiento deportivo es un proceso educativo, de enseñanza y aprendizaje, orientado a unos fines y adaptado a las características individuales de cada persona. En MY WORKOUT aprendemos y entrenamos.",
			}
		},
		{
			path: '/casos-de-exito',
			name: 'success-stories',
			component: SuccessStories,
			meta: {
				title: "My WorkOut Studio - Casos de éxito",
				description:
					"Casos de éxito de nuestros clientes, los que eligieron el camino largo.",
			}
		}, 
		{
			path: es.politica_privacidad,
			alias: en.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad
		},
		{
			path: es.politica_cookies,
			alias: en.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies
		},
		{
			path: '/aviso-legal',
			name: 'aviso-legal',
			component: avisoLegal
		},
		{
			path: '/faqs',
			name: 'faqs',
			component: faqs,
			meta: {
				title: "My WorkOut Studio -FAQs",
				description:
					"Preguntas frecuentes sobre MY WORKOUT",
			}
		},
		{ path: '*', redirect: '/404' },
		{ path: "/404", component: Error404 }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (!!to.hash) {
				return {
					selector: to.hash,
					offset: { x: 0, y: (window.innerWidth > 768) ? 60 : -100 }
				}
			} else {
				return { x: 0, y: 0 }
			}
		}
	}
});

import VueAnalytics from 'vue-analytics';


Vue.use(VueAnalytics, {
	id: "UA-141900711-1",
	router,
	debug: {
		// sendHitTask: location.hostname.includes("myworkoutstudio")
		enabled: false
	}
});

router.beforeEach((to, from, next) => {
	let meta;

	if (!!to.meta.title) {
		meta = to.meta;
	} else {
		meta = false;
	}


	if (!!meta) {
		document.title = meta.title;
		document.head.querySelector("[name=description]").content =
			meta.description;
		document.head.querySelector("[name=title]").content =
			meta.title;
	}

	next();
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js